import { FormControl, TextareaAutosize } from "@mui/material";
import { FormFieldValueGroupUI } from "Backend";
import { FormFieldContext } from "contexts/FormFieldContext";
import useDebounce from "helpers/useDebounce";
import { memo, useCallback, useContext, useEffect, useState } from "react";
import { TextareaStyle } from "theme";

const ValueGroupNotes = memo(
  function ValueGroupNotes({ group }: { group: FormFieldValueGroupUI }) {
    const ffContext = useContext(FormFieldContext);
    const delay = 500;
    const [internalValue, setInternalValue] = useState(group.notes || undefined);
    const debouncedValue = useDebounce(internalValue, delay);
    const onChange = (newNote?: string) => {
      ffContext.setValueGroupNotes(group.id, newNote);
    };
    const onInputChange = useCallback(
      (event) => {
        setInternalValue(event.target.value);
      },
      [setInternalValue]
    );

    useEffect(() => {
      if (group.notes !== internalValue) {
        setInternalValue(group.notes || "");
      }
    }, [group.notes]);

    useEffect(() => {
      if (debouncedValue !== group.notes) {
        onChange(debouncedValue);
      }
    }, [debouncedValue]);

    return (
      <FormControl fullWidth>
        <TextareaAutosize
          value={internalValue}
          className="max-h-48 text-sm"
          style={{
            ...TextareaStyle,
          }}
          onChange={onInputChange}
        />
      </FormControl>
    );
  },
  (prevProps, nextProps) => prevProps.group.id === nextProps.group.id
);

export default ValueGroupNotes;
